<template>
  <div class="container" id="top-page" style="background-color: #eef2f5">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Open Requests</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <tableComponent
            :tableHeaders="requestHeader"
            :tableItems="openResquestFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-top: 30px">
        <v-expansion-panel-header class="Header"
          >Closed Requests</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search2"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate2" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate2" class="input_date" />
            </div>
          </div>
          <br />
          <tableComponent
            :tableHeaders="requestHeader"
            :tableItems="closeResquestFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import tableComponent from '../table/tableComponent.vue';
import { mapGetters } from 'vuex';
import DecodeJWT from '../DecodeJWT';

export default {
  components: { tableComponent },
  mounted() {
    let token = localStorage.getItem('token');
    if (token == '' || !token) {
      this.$router.push('/login');
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push('/login');
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: 'smooth',
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQRequest();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, '0');
        let day = today.getDate().toString().padStart(2, '0');
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, '0');
        day = fromday.getDate().toString().padStart(2, '0');
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      requestHeader: [
        { text: 'Created Date', value: 'HDCase_CreatedDate' },
        { text: 'Case Number', value: 'HDCase_HDCaseNum' },
        {
          text: 'Case Description',
          value: 'HDCase_Description',
          sortable: true,
          class: 'width-wrap',
        },
        { text: 'Req PerCont ID', value: 'HDCase_ReqPerConID' },
        { text: 'PerCont Name', value: 'PerCon_Name' },
        { text: 'Case Owner', value: 'HDCase_CaseOwner' },
        { text: 'Serial Number', value: 'HDCase_SerialNumber' },
        { text: 'Equiptment ID', value: 'HDCase_EquipID' },
        { text: 'Priority', value: 'HDCase_Priority' },
        { text: 'Status', value: 'HDCase_HDCaseStatus' },
        { text: 'Service Call', value: 'HDCase_CallNum' },
        { text: 'Call Line', value: 'HDCase_CallLine' },
        { text: 'Part', value: 'HDCase_PartNum' },
        { text: 'Part Description', value: 'HDCase_PartDescription' },
      ],
      panel: [],
      openResquest: [],
      closeResquest: [],
      search1: "",
      search2: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
    };
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getOpenRequest", "getCloseRequest"]),
    openResquestFilter() {
      const filterKey = (this.search1 || '').toLowerCase();
      if (this.openResquest == null || filterKey === '')
        return this.openResquest;
      return this.openResquest.filter((i) => {
        return (
          i.HDCase_HDCaseNum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.HDCase_Description.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.HDCase_SerialNumber.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.HDCase_EquipID.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    openResquestFilterDate() {
      if (this.openResquest.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.openResquestFilter.filter((i) => {
          let day = i.HDCase_CreatedDate.split('/')[0];
          let month = i.HDCase_CreatedDate.split('/')[1];
          let year = i.HDCase_CreatedDate.split('/')[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.openResquestFilter;
      }
    },
    closeResquestFilter() {
      const filterKey = (this.search2 || '').toLowerCase();
      if (this.closeResquest == null || filterKey === '')
        return this.closeResquest;
      return this.closeResquest.filter((i) => {
        return (
          i.HDCase_HDCaseNum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.HDCase_Description.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.HDCase_SerialNumber.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.HDCase_EquipID.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    closeResquestFilterDate() {
      if (this.closeResquest.length > 0) {
        let from = new Date(this.fromdate2);
        let to = new Date(this.todate2);
        return this.closeResquest.filter((i) => {
          let day = i.HDCase_CreatedDate.split('/')[0];
          let month = i.HDCase_CreatedDate.split('/')[1];
          let year = i.HDCase_CreatedDate.split('/')[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.closeResquest;
      }
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getOpenRequest() {
      this.loadRequest();
    },
    getCloseRequest() {
      this.loadRequest();
    },
  },
  methods: {
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, '0');
        var month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return '';
    },
    async getBAQRequest() {
      await this.$store.dispatch('Data/getOpenRequestData');
      await this.$store.dispatch('Data/getCloseRequestData');
      this.loadRequest();
    },
    loadRequest() {
      this.openResquest = [];
      this.closeResquest = [];
      if (this.getOpenRequest.length > 0)
        this.getOpenRequest.forEach((el) => {
          this.openResquest.push({
            HDCase_CreatedDate: this.convertDate(el.HDCase_CreatedDate),
            HDCase_HDCaseNum: el.HDCase_HDCaseNum,
            HDCase_Description: el.HDCase_Description,
            HDCase_ReqPerConID: el.HDCase_ReqPerConID,
            HDCase_CaseOwner: el.HDCase_CaseOwner,
            PerCon_Name: el.PerCon_Name,
            HDCase_SerialNumber: el.HDCase_SerialNumber,
            HDCase_EquipID: el.HDCase_EquipID,
            HDCase_Priority: el.HDCase_Priority,
            HDCase_HDCaseStatus: el.HDCase_HDCaseStatus,
            HDCase_CallNum: el.HDCase_CallNum,
            HDCase_CallLine: el.HDCase_CallLine,
            HDCase_PartNum: el.HDCase_PartNum,
            HDCase_PartDescription: el.HDCase_PartDescription,
          });
        });
      if (this.getCloseRequest.length > 0)
        this.getCloseRequest.forEach((el) => {
          this.closeResquest.push({
            HDCase_CreatedDate: this.convertDate(el.HDCase_CreatedDate),
            HDCase_HDCaseNum: el.HDCase_HDCaseNum,
            HDCase_Description: el.HDCase_Description,
            HDCase_ReqPerConID: el.HDCase_ReqPerConID,
            HDCase_CaseOwner: el.HDCase_CaseOwner,
            PerCon_Name: el.PerCon_Name,
            HDCase_SerialNumber: el.HDCase_SerialNumber,
            HDCase_EquipID: el.HDCase_EquipID,
            HDCase_Priority: el.HDCase_Priority,
            HDCase_HDCaseStatus: el.HDCase_HDCaseStatus,
            HDCase_CallNum: el.HDCase_CallNum,
            HDCase_CallLine: el.HDCase_CallLine,
            HDCase_PartNum: el.HDCase_PartNum,
            HDCase_PartDescription: el.HDCase_PartDescription,
          });
        });
    },
  },
};
</script>

<style scoped>
.ml-20 {
  margin-left: 100px;
}

.input_date {
  outline: #d1dfe3;
}

.filter_date {
  display: flex;
  flex-direction: row;
}

.filter_date_item {
  display: flex;
  flex-direction: column;
}

.mb-20 {
  margin-bottom: 50px;
}

.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}

.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.input-search {
  margin-top: 5px;
  margin-bottom: 5px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}

.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}
</style>
